/* The Cart Room — interaction layer. No dependencies. Everything here is decoration:
   the page works exactly the same with JS off. */
(function () {
  'use strict';
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var canHover = window.matchMedia('(hover: hover)').matches;

  /* 1. Hero mascot. The eye slits are the logo's own shapes; the expression system
     signed off on the concept board:
     - a dead zone around centre where the face is exactly the resting logo
       (no pupils, no morph) — "not looking anywhere" is a region, not a pixel;
     - beyond it, both slits open wide the SAME way whether you look up or down
       (shape says how far, the pupil says which way);
     - pupils are dots clipped inside the slits, radius 0 at rest, growing with
       distance so they fade in instead of popping. */
  function initMascot() {
    var mascot = document.querySelector('.cr-hero__mascot');
    if (!mascot) return;
    var look = mascot.querySelector('.cr-hero__look');
    var eyeL = mascot.querySelector('.cr-eye--l'), eyeR = mascot.querySelector('.cr-eye--r');
    var clipL = mascot.querySelector('.cr-eyec--l'), clipR = mascot.querySelector('.cr-eyec--r');
    var pupL = mascot.querySelector('.cr-pupil--l'), pupR = mascot.querySelector('.cr-pupil--r');

    function quad(oX, iX, cO, hO, cI, hI) {
      return 'M' + oX + ' ' + (cO - hO).toFixed(1) +
             ' L' + iX + ' ' + (cI - hI).toFixed(1) +
             ' L' + iX + ' ' + (cI + hI).toFixed(1) +
             ' L' + oX + ' ' + (cO + hO).toFixed(1) + ' Z';
    }

    function setEyes(rawDx, rawDy) {
      if (!eyeL || !eyeR || !look) return;
      /* dead zone: inner 28% of the range = fully at rest */
      var dist = Math.hypot(rawDx, rawDy) || 1e-9;
      var t = Math.max(0, Math.min(1, (dist - 0.28) / 0.72));
      var k = t / dist, dx = rawDx * k, dy = rawDy * k;
      /* symmetric morph: reacts to how far you look, not which way vertically */
      var m = Math.abs(dy);
      var tilt = 20 - m * 22 * (1 - Math.abs(dx) * 0.45);
      var open = 1 + m * 0.5;
      var oL = open * (1 - dx * 0.08), oR = open * (1 + dx * 0.08);
      var cI0 = 162 + tilt * 0.85;
      var dL = quad(112, 158, 162, 14 * oL, cI0, 11 * oL);
      var dR = quad(208, 162, 162, 14 * oR, cI0, 11 * oR);
      eyeL.setAttribute('d', dL); eyeR.setAttribute('d', dR);
      if (clipL && clipR) { clipL.setAttribute('d', dL); clipR.setAttribute('d', dR); }
      if (pupL && pupR) {
        var pr = (8 * Math.min(1, t * 1.7)).toFixed(1);
        var yC = (162 + cI0) / 2 + dy * 5.5;
        pupL.setAttribute('cx', (135 + dx * 10).toFixed(1)); pupL.setAttribute('cy', yC.toFixed(1)); pupL.setAttribute('r', pr);
        pupR.setAttribute('cx', (185 + dx * 10).toFixed(1)); pupR.setAttribute('cy', yC.toFixed(1)); pupR.setAttribute('r', pr);
      }
      look.setAttribute('transform', 'translate(' + (dx * 18).toFixed(1) + ' ' + (dy * 12).toFixed(1) + ')');
    }

    if (!reduceMotion) {
      if (canHover) {
        var raf = null, mx = 0, my = 0;
        window.addEventListener('mousemove', function (e) {
          mx = e.clientX; my = e.clientY;
          if (raf) return;
          raf = requestAnimationFrame(function () {
            raf = null;
            var r = mascot.getBoundingClientRect();
            var dx = Math.max(-1, Math.min(1, (mx - (r.left + r.width / 2)) / 300));
            var dy = Math.max(-1, Math.min(1, (my - (r.top + r.height * 0.45)) / 240));
            setEyes(dx, dy);
          });
        }, { passive: true });
      } else {
        /* no cursor to follow: cycle through little expressions, resting in between */
        var seq = [[0.7, -0.5], [0, 0], [-0.7, 0.5], [0.8, 0.4], [0, 0], [0, -0.9]];
        var cur = { x: 0, y: 0 }, step = -1;
        setInterval(function () {
          var target = seq[step = (step + 1) % seq.length];
          var from = { x: cur.x, y: cur.y }, t0 = null;
          function tween(ts) {
            if (t0 === null) t0 = ts;
            var p = Math.min(1, (ts - t0) / 600);
            p = 1 - Math.pow(1 - p, 3);
            cur.x = from.x + (target[0] - from.x) * p;
            cur.y = from.y + (target[1] - from.y) * p;
            setEyes(cur.x, cur.y);
            if (p < 1) requestAnimationFrame(tween);
          }
          requestAnimationFrame(tween);
        }, 2600);
      }
    }

    mascot.addEventListener('click', function () {
      if (reduceMotion) return;
      mascot.classList.remove('is-wiggling');
      void mascot.offsetWidth; // restart the animation
      mascot.classList.add('is-wiggling');
    });
    mascot.addEventListener('animationend', function (e) {
      if (e.animationName === 'cr-wiggle') mascot.classList.remove('is-wiggling');
    });
  }

  /* 2. Basket pill bumps whenever the cart contents change (Origin re-renders the bubble). */
  function initBasketBump() {
    var pill = document.getElementById('cart-icon-bubble');
    if (!pill || !('MutationObserver' in window)) return;
    var last = pill.textContent.trim();
    new MutationObserver(function () {
      var now = pill.textContent.trim();
      if (now === last) return;
      last = now;
      if (reduceMotion) return;
      pill.classList.remove('is-bumping');
      void pill.offsetWidth;
      pill.classList.add('is-bumping');
    }).observe(pill, { childList: true, subtree: true, characterData: true });
    pill.addEventListener('animationend', function () { pill.classList.remove('is-bumping'); });
  }

  /* 3. Section titles and big stickers "stamp" into place as they scroll in. */
  function initStamps() {
    var els = document.querySelectorAll('.cr-section__title, .cr-colhead__title, .cr-join__title, .cr-deal, .cr-receipt, .cr-eyebrow');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cr-stamp', 'is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.2 });
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      el.classList.add('cr-stamp');
      // already on screen at load: settle immediately, never hide first-paint content
      if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in'); else io.observe(el);
    });
  }

  /* 4. Deal countdown: nudge a digit when it changes. */
  function initTimerTicks() {
    var timers = document.querySelectorAll('[data-cr-timer]');
    if (!timers.length || reduceMotion || !('MutationObserver' in window)) return;
    timers.forEach(function (t) {
      t.querySelectorAll('.cr-timer__num').forEach(function (num) {
        new MutationObserver(function () {
          num.classList.remove('is-tick'); void num.offsetWidth; num.classList.add('is-tick');
        }).observe(num, { childList: true, characterData: true, subtree: true });
      });
    });
  }

  function start() { initMascot(); initBasketBump(); initStamps(); initTimerTicks(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
